import ListingsFilters from './ListingFilters.container';

export default ListingsFilters;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/ListingFilters/index.js